import { render, staticRenderFns } from "./SalesDashboardHeader.vue?vue&type=template&id=6d330238&scoped=true"
import script from "./SalesDashboardHeader.vue?vue&type=script&lang=js"
export * from "./SalesDashboardHeader.vue?vue&type=script&lang=js"
import style0 from "./SalesDashboardHeader.vue?vue&type=style&index=0&id=6d330238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d330238",
  null
  
)

export default component.exports